import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "../utils/axios";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [contact, setContact] = useState(null);
  const [loadingContact, setLoadingContact] = useState(true);

  // Fetch Contact Details from server
  const fetchContact = async () => {
    try {
      const res = await axios.get("/contacts");
      // console.log("contact:", res.data);
      setContact(res.data);
    } catch (err) {
      console.error("Error fetching contact details:", err);
    } finally {
      setLoadingContact(false);
    }
  };

  useEffect(() => {
    fetchContact();
  }, []);

  return (
    <AppContext.Provider
      value={{
        contact,
        loadingContact,
        refreshContact: fetchContact,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
